module.exports = __webpack_public_path__ + "static/media/chair_green_icon.d0eb2e29.svg";